module.exports = __webpack_public_path__ + "static/media/VWFS_Logo_FR.16edec07.png";